import { Chip, Stack, Tooltip, Typography } from '@mui/material'
import React from 'react'

import Icon from 'components/Icon'
import { pluralize } from 'utils/strings'

export const KubernetesListItemTags: React.FC<{
  isSelected?: boolean
  tags: Record<string, any>
}> = ({ isSelected, tags }) => {
  const { cluster, namespace, podCount, replicaSetCount, unhealthyPods } = tags

  const hasPods = podCount > 0
  const hasReplicaSets = replicaSetCount > 0
  const color = isSelected ? 'primary' : 'default'

  return (
    <Stack direction="row" gap={1}>
      {unhealthyPods.length > 0 && (
        <Tooltip
          arrow
          placement="top"
          title={`${unhealthyPods} ${
            unhealthyPods.length === 1 ? 'is' : 'are'
          } not healthy. Your attack may not be successful.`}
        >
          <Typography color="warning.main">
            <Icon
              data-test-tag-selection-warning-icon
              css={{ height: 24 }}
              icon="warning"
            />
          </Typography>
        </Tooltip>
      )}
      <Tooltip arrow placement="top" title={`Cluster: ${cluster}`}>
        <Chip
          color={color}
          label={
            <Typography noWrap fontFamily="monospace" variant="caption">
              {cluster}
            </Typography>
          }
          size="small"
          sx={{
            maxWidth: 256
          }}
          variant="outlined"
        />
      </Tooltip>
      <Tooltip arrow placement="top" title={`Namespace: ${namespace}`}>
        <Chip
          color={color}
          label={
            <Typography noWrap fontFamily="monospace" variant="caption">
              {namespace}
            </Typography>
          }
          size="small"
          sx={{
            maxWidth: 256
          }}
          variant="outlined"
        />
      </Tooltip>
      {hasReplicaSets && (
        <Chip
          data-test-replica-set-count-chip
          color={color}
          label={
            <Typography
              fontFamily="monospace"
              variant="caption"
            >{`${replicaSetCount} ${pluralize(
              'ReplicaSet',
              replicaSetCount
            )}`}</Typography>
          }
          size="small"
          variant="outlined"
        />
      )}
      {hasPods && (
        <Chip
          data-test-pod-count-chip
          color={color}
          label={
            <Typography fontFamily="monospace" variant="caption">
              {`${podCount} ${pluralize('Pod', podCount)}`}
            </Typography>
          }
          size="small"
          variant="outlined"
        />
      )}
    </Stack>
  )
}
